import { useTranslation } from "@redotech/redo-i18n";
import { ItemDiscountMeasureOption } from "@redotech/redo-return-core-common/return-flow/condition-enums";
import type { ItemDiscountState } from "@redotech/redo-return-core-common/return-flow/condition-validate";
import { ConditionTypeDetailsProps } from "@redotech/redo-return-ui/flows/return-flow/condition";
import { RedoTextInput } from "@redotech/redo-web/arbiter-components/input/redo-text-input";
import {
  RadioGroupOption,
  RedoRadioGroup,
} from "@redotech/redo-web/arbiter-components/radio/redo-radio-group";
import { memo } from "react";

function measureOptions(
  t: (key: string) => string,
): RadioGroupOption<ItemDiscountMeasureOption>[] {
  return [
    { id: ItemDiscountMeasureOption.PERCENT, label: "%" },
    { id: ItemDiscountMeasureOption.AMOUNT, label: t("Raw amount") },
  ];
}

export const ItemDiscountDetails = memo(function ItemDiscountDetails({
  state,
  setState,
}: ConditionTypeDetailsProps<ItemDiscountState>) {
  const { t } = useTranslation();
  const description =
    state.measureOption == ItemDiscountMeasureOption.PERCENT
      ? t(
          "If the item is discounted by more than {{value}}% from its original price",
          { value: state.value },
        )
      : t("If the item is discounted by {{value}} or greater", {
          value: state.value,
        });
  return (
    <>
      <RedoRadioGroup
        options={measureOptions(t)}
        setValue={(measureOption) => setState({ ...state, measureOption })}
        size="xs"
        value={state.measureOption}
      />
      <RedoTextInput
        description={description}
        inputTypeHint="number"
        label={t("Value")}
        max={
          state.measureOption === ItemDiscountMeasureOption.PERCENT
            ? 100
            : undefined
        }
        min={0}
        setValue={(e) => {
          setState({ ...state, value: +e });
        }}
        size="sm"
        value={state.value.toString()}
      />
    </>
  );
});
